import React from 'react';

const About = () => {
  return (
    <section id="about" className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 max-w-2xl"><p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-700">About me</p><h2 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">Curious by nature, practical by design.</h2></div>
        <div className="grid items-start gap-12 md:grid-cols-2">
          <div>
            <p className="text-lg leading-8 text-slate-600 mb-6">
              I'm a Cum Laude graduate of Cebu Technological University's Bachelor of Science in
              Information Technology program, with a passion for creating innovative solutions using
              modern technologies. My journey in tech has led me to work on projects ranging from
              AI-powered applications to full-stack web and mobile development.
            </p>
            <p className="text-lg leading-8 text-slate-600">
              With experience in Python, JavaScript, React, React Native, and Django, I enjoy 
              tackling challenging problems and building applications that make a real impact in 
              communities and everyday life.
            </p>
          </div>
          
          <div className="rounded-3xl border border-slate-200 bg-white p-7 shadow-sm">
            <h3 className="text-xl font-bold text-slate-950">Education</h3>
            <div className="mt-6 space-y-6">
              <div className="border-l-2 border-cyan-500 pl-4">
                <p className="font-semibold text-slate-950">Cebu Technological University Main Campus</p>
                <p className="mt-1 text-sm text-slate-600">Bachelor of Science in Information Technology</p>
                <p className="mt-1 text-xs font-semibold text-cyan-700">2022 — Graduate · Cum Laude</p>
              </div>
              <div className="border-l-2 border-slate-200 pl-4">
                <p className="font-semibold text-slate-800">Asian College of Technology Bulacao Campus</p>
                <p className="mt-1 text-xs text-slate-500">2020 — 2022</p>
              </div>
              <div className="border-l-2 border-slate-200 pl-4">
                <p className="font-semibold text-slate-800">University of the Visayas Pardo Campus</p>
                <p className="mt-1 text-xs text-slate-500">2018 — 2020</p>
              </div>
              <div className="border-l-2 border-slate-200 pl-4">
                <p className="font-semibold text-slate-800">St. Scholastica's Academy Tabunok</p>
                <p className="mt-1 text-xs text-slate-500">2016 — 2018</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
